"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function dispatchFilterRemovalEvent(filter) {
  if (filter === 'ideationStatus') {
    window.dispatchEvent(new CustomEvent('ideationStatusFilterRemoval'));
    return;
  }

  if (filter === 'productArea') {
    window.dispatchEvent(new CustomEvent('productAreaFilterRemoval'));
    return;
  }

  if (filter === 'category') {
    window.dispatchEvent(new CustomEvent('categoryFilterRemoval'));
  }
}

var _default = dispatchFilterRemovalEvent;
exports.default = _default;